import Decimal from 'decimal.js';
import type { Row } from '../../lib/row';
import type { Meta } from '../../next/meta';
import { venueName } from '../../next/meta';
import { venueCanon } from '../../next/venues';
import { editAmount, isRubStake } from '../../next/show';
import { useSettings } from '../../store/settings';
import { request } from './api';
import { planMarket, planTiming } from './links';
import type { Command, Report } from './types';

/** План вилки для кассы. Принятие пустое: купон ещё не сверен. */
export function feedPlanData(
  row: Row,
  meta: Meta,
  accounts: { id: string; venue: string; currency: string }[],
  repeat: boolean,
  fx: number,
): Record<string, unknown> {
  if (row.legs.some((leg) => leg.lay))
    throw new Error('для ставки против нужна ручная запись с проверкой обязательства');
  const fields: Record<string, string> = {
    name: row.legs[0]?.who.join(' — ') || 'сделка из ленты',
    sport: row.fork.sport || '',
    legCount: String(row.legs.length),
    forkId: row.fork.id,
    timing: planTiming(row.fork.line),
    market: planMarket(row.fork),
  };
  row.legs.forEach((leg, i) => {
    const currency = isRubStake(leg, meta) ? 'RUB' : 'USD';
    const planned = editAmount(leg, fx, meta);
    let plannedOk = false;
    try {
      plannedOk = new Decimal(planned).gt(0);
    } catch {
      plannedOk = false;
    }
    if (!plannedOk) throw new Error('в плане нет суммы ставки; укажите её в калькуляторе');
    const book = venueCanon(leg.source);
    const matches = accounts.filter(
      (account) =>
        venueCanon(account.venue) === book && account.currency === currency,
    );
    fields['account' + i] = matches.length === 1 ? matches[0]!.id : '';
    fields['planned' + i] = planned;
    fields['accepted' + i] = '';
    fields['funding' + i] = leg.freebet ? 'freebet' : 'cash';
    fields['odds' + i] = leg.odds;
    fields['fee' + i] = '0';
    fields['side' + i] = leg.name || leg.side;
    fields['venue' + i] = leg.source;
    fields['venueName' + i] = venueName(meta, leg.source);
    fields['currency' + i] = currency;
  });
  return {
    id: crypto.randomUUID(),
    newEntry: repeat,
    captureVersion: 1,
    ...fields,
  };
}

/** «Поставил» оставляет план в журнале и не мешает ленте, если касса молчит. */
export async function rememberFeedPlan(row: Row, meta: Meta): Promise<void> {
  if (row.legs.some((leg) => leg.lay)) return;
  try {
    const report = await request<Report>('');
    if (
      report.trades?.some(
        (trade) => trade.forkId === row.fork.id && trade.status !== 'cancelled',
      )
    )
      return;
    const command: Command = {
      requestId: crypto.randomUUID(),
      revision: report.revision,
      action: 'draft',
      data: feedPlanData(row, meta, report.accounts, false, useSettings.getState().fx),
    };
    await request('/command', command);
  } catch {
    // Нет входа или нет суммы — отметка темпа уже сделана.
  }
}
